import { render, staticRenderFns } from "./MenuFinanceiro.vue?vue&type=template&id=5102bc4f&scoped=true"
import script from "./MenuFinanceiro.vue?vue&type=script&lang=js"
export * from "./MenuFinanceiro.vue?vue&type=script&lang=js"
import style0 from "./MenuFinanceiro.vue?vue&type=style&index=0&id=5102bc4f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5102bc4f",
  null
  
)

export default component.exports